import { get, post } from '..';

// The driver-notification send lives on the nestjs admin service (/admin/*) as
// REST — not the deprecated admin GraphQL API. The admin backend resolves the
// city's drivers and fans out the pushes (re-implementing the old /notifications
// flow Retool used); the dashboard only supplies the message + route and never
// handles device tokens.

// How many drivers a broadcast to this city would reach — for the send-preview.
// `xlOnly` picks the driver segment: false (default) counts drivers WITHOUT the
// XL tag; true counts ONLY drivers tagged XL.
const getRecipientCount = async (homeCity, xlOnly = false) => {
  const { data } = await get(
    `/admin/notifications/drivers/recipient-count?homeCity=${encodeURIComponent(
      homeCity,
    )}&xlOnly=${encodeURIComponent(xlOnly)}`,
  );
  return data.count;
};

// Fire the broadcast. Returns { queued } — the count the backend actually sent.
// `tripId` is only set when the send targets one specific trip (the trips-page
// dispatch); it's carried through as data so the app can deep-link the push to
// that exact trip. The generic city tool omits it.
// `xlOnly` picks the driver segment: false (default) sends to drivers WITHOUT
// the XL tag; true sends to ONLY drivers tagged XL. The two segments are
// mutually exclusive — a send never reaches both.
const sendDriverNotifications = async ({
  homeCity,
  title,
  body,
  event,
  origin,
  destination,
  when,
  tripId,
  xlOnly = false,
}) => {
  const { data } = await post('/admin/notifications/drivers/broadcast', {
    homeCity,
    title,
    body,
    event,
    origin,
    destination,
    when,
    tripId,
    xlOnly,
  });
  return data;
};

// Recent broadcasts, newest first — the source for the sent-log. `days` is the
// look-back window (backend defaults to 7). Returns the `broadcasts` array.
const getBroadcastHistory = async (days = 7) => {
  const { data } = await get(`/admin/notifications/broadcast/history?days=${encodeURIComponent(days)}`);
  return data.broadcasts || [];
};

export { getRecipientCount, sendDriverNotifications, getBroadcastHistory };
